import { render } from "./select-week-days.vue?vue&type=template&id=e6be3cee&scoped=true"
import script from "./select-week-days.vue?vue&type=script&lang=js"
export * from "./select-week-days.vue?vue&type=script&lang=js"

import "./select-week-days.vue?vue&type=style&index=0&id=e6be3cee&lang=scss&scoped=true"

import exportComponent from "/home/node/ks-web/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-e6be3cee"]])

export default __exports__